module.exports = __webpack_public_path__ + "static/music-418f92276662ce52120e4a2ff9815c23.jpg";